// По умолчанию по закрытию диалога убиваем его. Если нужно другое поведение,
// реализуем его в каждом конкретном случае индивидуально
// Выполняем через таймаут, так как иначе в хроме в других обработчиках
// невозможно понять, клик был внутри диалога или нет
"use strict";
$.ui.dialog.prototype.options.close = function () {
    var dialog = $(this);
    setTimeout(function () {
        if (dialog)
            dialog.dialog("destroy");
    }, 0);
};
$.ui.dialog.prototype.options.dialogClass = 'fotobook-dialog';
$.ui.dialog.prototype.options.closeText = t('photobook-js-dialog-closeText');
$.ui.dialog.prototype.addClass = function (classes) {
    this.uiDialog.addClass(classes);
    return this;
}
$.ui.dialog.prototype.removeClass = function (classes) {
    this.uiDialog.removeClass(classes);
    return this;
}
$.ui.dialog.prototype.hasClass = function (classes) {
    return this.uiDialog.hasClass(classes);
}